<template>
  <div class="creator-account-settings">
    <div class="toolbar">
      <div>
        <div class="title">作品监测账号</div>
        <div class="description">每个平台配置一个账号。抖音和 B站用于运营指标，视频号用于同步作品并采集作品评论。</div>
      </div>
      <el-button type="primary" icon="el-icon-plus" :disabled="hasPendingAction" @click="add">添加账号</el-button>
    </div>
    <el-alert type="info" :closable="false" show-icon title="B站和抖音可从主页识别账号 ID；视频号需填写 TikHub finder username（v2_...@finder）。"/>
    <el-table v-loading="loading" :data="accounts" class="account-table" empty-text="请添加需要自动采集的平台账号">
      <el-table-column label="平台" width="110"><template slot-scope="scope"><platform-tag :value="scope.row.platform"/></template></el-table-column>
      <el-table-column label="账号" min-width="180"><template slot-scope="scope"><div>{{ scope.row.account_name || scope.row.account_id }}</div><div class="muted">{{ scope.row.account_id }}</div></template></el-table-column>
      <el-table-column label="自动同步" width="110"><template slot-scope="scope"><el-tag :type="scope.row.enabled ? 'success' : 'info'">{{ scope.row.enabled ? '已启用' : '已停用' }}</el-tag></template></el-table-column>
      <el-table-column label="最近同步" width="170"><template slot-scope="scope">{{ formatDate(scope.row.last_success_at) || '尚未同步' }}</template></el-table-column>
      <el-table-column label="最近结果" min-width="200" show-overflow-tooltip><template slot-scope="scope"><span :class="scope.row.last_error ? 'failed' : ''">{{ scope.row.last_error || '正常' }}</span></template></el-table-column>
      <el-table-column label="操作" width="330" fixed="right">
        <template slot-scope="scope">
          <el-button
            type="text"
            :loading="syncingId === scope.row.id && !syncingHistory"
            :disabled="hasPendingAction"
            @click="sync(scope.row, false)"
          >{{ syncingId === scope.row.id && !syncingHistory ? '同步中' : '同步最新' }}</el-button>
          <el-button
            type="text"
            :loading="syncingId === scope.row.id && syncingHistory"
            :disabled="hasPendingAction"
            @click="sync(scope.row, true)"
          >{{ syncingId === scope.row.id && syncingHistory ? '补采中' : '补历史' }}</el-button>
          <el-button type="text" :disabled="hasPendingAction" @click="edit(scope.row)">编辑</el-button>
          <el-button type="text" class="danger" :loading="deletingId===scope.row.id" :disabled="hasPendingAction&&deletingId!==scope.row.id" @click="remove(scope.row)">{{deletingId===scope.row.id?'删除中':'删除'}}</el-button>
        </template>
      </el-table-column>
    </el-table>
    <creator-account-dialog :visible.sync="dialogVisible" :editing="editing" @success="load"/>
  </div>
</template>

<script>
import { yuqingApi } from '@/api/yuqing'
import PlatformTag from '../components/PlatformTag.vue'
import CreatorAccountDialog from '../creator/CreatorAccountDialog.vue'

export default {
  components: { PlatformTag, CreatorAccountDialog },
  data () { return { loading: false, accounts: [], dialogVisible: false, editing: null, syncingId: '', syncingHistory: false, deletingId: '' } },
  computed: { hasPendingAction () { return !!this.syncingId || !!this.deletingId } },
  mounted () { this.load() },
  methods: {
    async load () { this.loading = true; try { this.accounts = (await yuqingApi.get('creator-accounts')).items || [] } catch (error) { this.$message.error(error.message || '账号配置加载失败') } finally { this.loading = false } },
    add () { this.editing = null; this.dialogVisible = true },
    edit (account) { this.editing = { ...account }; this.dialogVisible = true },
    async sync (account, initial) {
      if (this.hasPendingAction) return
      if (initial) { try { await this.$confirm('将继续按发布时间读取历史作品，调用次数会多于日常同步。是否继续？', '补历史作品', { type: 'warning' }) } catch (error) { return } }
      this.syncingId = account.id
      this.syncingHistory = initial
      try { const result = await yuqingApi.post(`creator-accounts/${account.id}/sync`, { initial }); const sync = result.sync || {}; this.$message.success(`同步完成：新增 ${sync.discovered || 0} 条，已存在 ${sync.existing || 0} 条`); await this.load() } catch (error) { this.$message.error(error.message || '账号同步失败') } finally { this.syncingId = ''; this.syncingHistory = false }
    },
    async remove (account) {
      if (this.hasPendingAction) return
      try {
        await this.$confirm(`删除“${account.account_name || account.account_id}”的自动采集配置？已有作品和指标不会删除。`, '删除监测账号', { type: 'warning' })
        this.deletingId = account.id
        await yuqingApi.delete(`creator-accounts/${account.id}`)
        this.$message.success('账号配置已删除')
        await this.load()
      } catch (error) {
        if (error !== 'cancel' && error !== 'close') this.$message.error(error.message || '删除失败')
      } finally {
        this.deletingId = ''
      }
    },
    formatDate (value) { return value ? String(value).replace('T', ' ').slice(0, 16) : '' }
  }
}
</script>

<style scoped>
.toolbar { display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 16px }
.title { color: #303133; font-size: 16px; font-weight: 600; line-height: 24px }
.description { color: #606266; font-size: 13px; line-height: 20px; margin-top: 2px }
.account-table { margin-top: 16px }
.muted { color: #909399; font-size: 12px; margin-top: 4px }
.failed, .danger { color: #f56c6c }
</style>
